import {RegistrationViewType} from '@models/RegistrationViewType';
import persistentStore from '@store/persistentStore';
import { shallow } from 'zustand/shallow';
import SmallCardView from '@components/SmallCardView';
import GridView from '../Views/CardView/GridView';
import ListView from '../Views/FullDayView/ListView';
import SwipeDeck from '../Views/SwipeView/SwipeDeck';
import {useStore} from '@store/appStore';
import DefaultLoader, {LoaderContainer, LoaderContainer2} from '@components/Loaders/DefaultLoader/DefaultLoader';
import ScheduleErrorContainer from '@components/ScheduleErrorContainer';
import styled from '@emotion/styled';

export const RegistrationViewHandler = ({ handleSelectedStudent }) => {
  
  const { registrationView } = persistentStore();
  const { students, error, schedule } = useStore(
    (state) => ({
      schedule: state.schedule,
      students: state.students,
      error: state.error,
    }),
    shallow,
  );



  return (
    <ViewWrapper>
      {schedule.loading ? (
        <LoaderContainer>
          <DefaultLoader />
        </LoaderContainer>
      ) : error.schedule || error.students ? (
        <LoaderContainer>
          <ScheduleErrorContainer error={error} />
        </LoaderContainer>
      ) : registrationView === RegistrationViewType.FULL_DAY ? (
          <ListView students={students} schedule={schedule} />
        ) : registrationView === RegistrationViewType.CARD ? (
          <SmallCardView onStudentSelected={handleSelectedStudent} students={students} />
        ) : registrationView === RegistrationViewType.GRID ? (
          <GridView onStudentSelected={handleSelectedStudent} students={students} />
        ) : 
          students.data?.length > 0 ? <SwipeDeck students={students} /> 
          : 
          <DefaultLoader />
      }
      
    </ViewWrapper>
  );
};

export default RegistrationViewHandler;


export const ViewWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: calc(var(--site-height) - var(--header-height) - var(--regi-nav-height));
`;